import cn from 'classnames';
import { SetStateAction, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../../UI/Button/Button';
import { Role } from '../../types/types';
import { Modal } from '../Modal/Modal';
import styles from './Register.module.scss';
import OrganizationRegisterForm from './OrganizationRegisterForm';
import StudentRegisterForm from './StudentRegisterForm';

export const Register = () => {
    return (
        <Modal>
            <RegisterFormLayout />
        </Modal>
    );
};

const RegisterFormLayout = () => {
    const [role, setRole] = useState<Role>(Role.candidate);
    const location = useLocation();
    const isLoginPopupOpen = location.search.includes('login');
    return (
        <div className={styles.formlayout}>
            <div className={styles.formlayout__wrapper}>
                <h4 className={styles.formlayout__header}>
                    {isLoginPopupOpen ? 'Авторизоваться' : 'Создать профиль'}
                </h4>
                <p className={styles.formlayout__description}>
                    Для использования всех функций сайта выберите, к какой
                    категории пользователей вы относитесь
                </p>
                <div className={styles.formlayout__chooserole}>
                    <Button
                        isDisabled={false}
                        onClick={() => setRole(Role.candidate)}
                        className={cn(styles.formlayout__student, {
                            [styles.formlayout__active]:
                                role === Role.candidate,
                        })}
                    >
                        Студент
                    </Button>
                    <Button
                        isDisabled={false}
                        onClick={() => setRole(Role.organization)}
                        className={cn(styles.formlayout__organization, {
                            [styles.formlayout__active]:
                                role === Role.organization,
                        })}
                    >
                        Организация
                    </Button>
                </div>

                <RegisterForm role={role} setRole={setRole} />

                <div className={styles.formlayout__footer}>
                    {!isLoginPopupOpen ? (
                        <>
                            <span className={styles.formlayout__footer_text}>
                                Уже есть профиль?
                            </span>
                            <Link
                                onClick={() => { }}
                                className={styles.formlayout__footer_button}
                                to={{ search: '?login=true' }}
                            >
                                Войти
                            </Link>
                        </>
                    ) : (
                        <>
                            <span className={styles.formlayout__footer_text}>
                                Еще нет профиля?
                            </span>
                            <Link
                                onClick={() => { }}
                                className={styles.formlayout__footer_button}
                                to={{ search: '?register=true' }}
                            >
                                Зарегистрироваться
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

interface RegisterFormProps {
    role?: Role;
    setRole?: React.Dispatch<SetStateAction<Role>>;
}

export const RegisterForm = ({ role, setRole }: RegisterFormProps) => {
    return (
        <div className={styles.RegisterForm}>
            <div className={styles.inputs}>
                {role === Role.candidate || role === Role.staff ? (
                    <StudentRegisterForm />
                ) : null}
                {role === Role.organization ? (
                    <OrganizationRegisterForm />
                ) : null}
            </div>
        </div>
    );
};
